import { GraphQLError } from 'graphql';

export const hasErrorType = (error: any, apolloErrorType: string): boolean => (
  error?.graphQLErrors?.some((graphQLError: any) => (
    graphQLError.extensions?.response?.body?.errors?.some((respError: any) => (
      respError?.code === apolloErrorType
    ))
  ))
);

export const getErrors = (graphQLError: GraphQLError): any => (
  graphQLError?.extensions?.response?.body?.errors
);

export const getGlobalError = (graphQLError: GraphQLError): any => (
  graphQLError?.extensions?.response?.body?.error
);
